import { render } from "./DeployVM.vue?vue&type=template&id=0ed71a97&scoped=true"
import script from "./DeployVM.vue?vue&type=script&lang=js"
export * from "./DeployVM.vue?vue&type=script&lang=js"

import "./DeployVM.vue?vue&type=style&index=0&id=0ed71a97&lang=less&scoped=true"
import "./DeployVM.vue?vue&type=style&index=1&id=0ed71a97&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed71a97"]])

export default __exports__